import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function TermsOfService() {
  const lastUpdated = "28/06/2026";

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar forceSolid />

      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8">
            <Link to="/" className="hover:text-foreground-600 transition-colors no-underline">Trang chủ</Link>
            <i className="ri-arrow-right-s-line text-sm"></i>
            <span className="text-foreground-600">Điều khoản sử dụng</span>
          </nav>

          {/* Header */}
          <div className="mb-10">
            <h1 className="font-heading font-bold text-3xl text-foreground-950 mb-3">Điều khoản sử dụng</h1>
            <p className="text-sm text-foreground-500">Cập nhật lần cuối: {lastUpdated}</p>
          </div>

          {/* Content */}
          <article className="prose prose-sm max-w-none text-foreground-700 space-y-8">
            {/* Acceptance */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">1. Chấp nhận điều khoản</h2>
              <p className="text-sm leading-relaxed">
                Bằng việc truy cập và sử dụng trang web <strong>Vietnam.cv</strong> ("Dịch vụ"), bạn đồng ý bị ràng buộc 
                bởi các Điều khoản sử dụng này. Nếu bạn không đồng ý với bất kỳ điều khoản nào, vui lòng không sử dụng Dịch vụ.
              </p>
              <p className="text-sm leading-relaxed mt-3">
                Vietnam.cv là nền tảng kết nối việc làm <strong>hoàn toàn miễn phí</strong>, cung cấp dịch vụ cho cả người tìm việc 
                và nhà tuyển dụng tại Việt Nam. Chúng tôi không thu bất kỳ khoản phí nào từ người dùng.
              </p>
            </section>

            {/* Eligibility */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">2. Điều kiện sử dụng</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Bạn phải từ đủ 16 tuổi trở lên để sử dụng Dịch vụ.</li>
                <li>Bạn cam kết cung cấp thông tin chính xác, đầy đủ và cập nhật khi đăng ký tài khoản.</li>
                <li>Bạn chịu trách nhiệm bảo mật thông tin đăng nhập và mọi hoạt động diễn ra trong tài khoản của mình.</li>
                <li>Mỗi cá nhân hoặc doanh nghiệp chỉ được phép tạo và duy trì một tài khoản duy nhất.</li>
              </ul>
            </section>

            {/* User Obligations */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">3. Nghĩa vụ của người dùng</h2>
              <p className="text-sm leading-relaxed">Khi sử dụng Dịch vụ, bạn cam kết <strong>KHÔNG</strong> thực hiện các hành vi sau:</p>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed mt-2">
                <li>Đăng tải thông tin sai sự thật, lừa đảo hoặc gây hiểu nhầm.</li>
                <li>Đăng tải tin tuyển dụng cho các công việc bất hợp pháp, vi phạm pháp luật Việt Nam.</li>
                <li>Đăng tải nội dung phân biệt đối xử, kỳ thị chủng tộc, tôn giáo, giới tính hoặc xúc phạm người khác.</li>
                <li>Sử dụng Dịch vụ để gửi thư rác, quảng cáo không mong muốn hoặc lừa đảo.</li>
                <li>Thu thập thông tin cá nhân của người dùng khác mà không được sự đồng ý.</li>
                <li>Can thiệp, phá hoại hoặc tấn công hệ thống kỹ thuật của Vietnam.cv.</li>
                <li>Sử dụng Dịch vụ cho bất kỳ mục đích thương mại trái phép nào.</li>
                <li>Mạo danh người khác hoặc tổ chức khác.</li>
              </ul>
            </section>

            {/* For Job Seekers */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">4. Dành cho người tìm việc</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Bạn có quyền tạo tài khoản miễn phí, tạo CV trực tuyến và ứng tuyển vào các vị trí tuyển dụng.</li>
                <li>Thông tin CV và hồ sơ của bạn sẽ được chia sẻ với nhà tuyển dụng khi bạn chủ động ứng tuyển.</li>
                <li>Bạn có trách nhiệm đảm bảo thông tin trong CV là chính xác và trung thực.</li>
                <li>Vietnam.cv không đảm bảo bạn sẽ được tuyển dụng hoặc nhận được phản hồi từ nhà tuyển dụng.</li>
                <li>Chúng tôi khuyến nghị bạn không cung cấp thông tin nhạy cảm (như số CMND/CCCD, tài khoản ngân hàng) trong CV hoặc thư xin việc.</li>
              </ul>
            </section>

            {/* For Employers */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">5. Dành cho nhà tuyển dụng</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Doanh nghiệp được đăng tin tuyển dụng miễn phí sau khi đăng ký tài khoản doanh nghiệp.</li>
                <li>Tin tuyển dụng phải mô tả chính xác vị trí, yêu cầu và quyền lợi của công việc.</li>
                <li>Tin tuyển dụng sẽ được đội ngũ quản trị kiểm duyệt trước khi hiển thị công khai để đảm bảo chất lượng.</li>
                <li>Bạn cam kết tuân thủ pháp luật lao động Việt Nam và không phân biệt đối xử trong tuyển dụng.</li>
                <li>Thông tin ứng viên nhận được chỉ được sử dụng cho mục đích tuyển dụng, không được sử dụng cho mục đích khác.</li>
                <li>Vietnam.cv có quyền gỡ bỏ tin tuyển dụng vi phạm điều khoản mà không cần báo trước.</li>
              </ul>
            </section>

            {/* Content & Intellectual Property */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">6. Sở hữu trí tuệ</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Tên, logo, giao diện và mã nguồn của Vietnam.cv thuộc quyền sở hữu của chúng tôi.</li>
                <li>Nội dung do người dùng đăng tải (tin tuyển dụng, CV) thuộc quyền sở hữu của người đăng tải.</li>
                <li>Bằng việc đăng tải nội dung lên Vietnam.cv, bạn cấp cho chúng tôi quyền sử dụng, hiển thị và phân phối nội dung đó trong khuôn khổ Dịch vụ.</li>
                <li>Bạn không được sao chép, phân phối hoặc sử dụng nội dung của người khác khi chưa được phép.</li>
              </ul>
            </section>

            {/* Disclaimer */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">7. Giới hạn trách nhiệm</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Vietnam.cv hoạt động như một nền tảng trung gian kết nối người tìm việc và nhà tuyển dụng.</li>
                <li>Chúng tôi không chịu trách nhiệm về tính chính xác của thông tin do người dùng đăng tải.</li>
                <li>Chúng tôi không chịu trách nhiệm về các thỏa thuận, giao dịch hoặc tranh chấp giữa người tìm việc và nhà tuyển dụng.</li>
                <li>Dịch vụ được cung cấp "như hiện trạng" mà không có bất kỳ bảo đảm nào, dù rõ ràng hay ngụ ý.</li>
                <li>Trong mọi trường hợp, trách nhiệm của Vietnam.cv không vượt quá số tiền (nếu có) mà bạn đã thanh toán cho chúng tôi. Do dịch vụ hoàn toàn miễn phí, trách nhiệm tài chính của chúng tôi là bằng không.</li>
              </ul>
            </section>

            {/* Termination */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">8. Chấm dứt tài khoản</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Bạn có thể ngừng sử dụng Dịch vụ và yêu cầu xóa tài khoản bất cứ lúc nào.</li>
                <li>Chúng tôi có quyền tạm ngừng hoặc chấm dứt tài khoản của bạn nếu bạn vi phạm các điều khoản này.</li>
                <li>Sau khi chấm dứt, dữ liệu của bạn sẽ được xử lý theo Chính sách bảo mật của chúng tôi.</li>
              </ul>
            </section>

            {/* Governing Law */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">9. Luật áp dụng</h2>
              <p className="text-sm leading-relaxed">
                Các điều khoản này được điều chỉnh và giải thích theo pháp luật nước Cộng hòa Xã hội Chủ nghĩa Việt Nam. 
                Mọi tranh chấp phát sinh sẽ được giải quyết thông qua thương lượng, hòa giải. Nếu không đạt được thỏa thuận, 
                tranh chấp sẽ được giải quyết tại tòa án có thẩm quyền tại Việt Nam.
              </p>
            </section>

            {/* Changes */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">10. Thay đổi điều khoản</h2>
              <p className="text-sm leading-relaxed">
                Chúng tôi có quyền sửa đổi các điều khoản này bất cứ lúc nào. Các thay đổi sẽ có hiệu lực ngay khi được 
                đăng tải trên trang web. Việc bạn tiếp tục sử dụng Dịch vụ sau khi thay đổi được đăng tải đồng nghĩa với 
                việc bạn chấp nhận các điều khoản mới. Chúng tôi khuyến nghị bạn thường xuyên kiểm tra trang này để cập nhật.
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">11. Liên hệ</h2>
              <p className="text-sm leading-relaxed">
                Nếu bạn có bất kỳ câu hỏi hoặc góp ý nào về các điều khoản sử dụng này, vui lòng liên hệ:
              </p>
              <ul className="list-disc pl-5 space-y-1 text-sm leading-relaxed mt-2">
                <li>Email: <a href="mailto:support@vietnam.cv" className="text-primary-600 hover:text-primary-700">support@vietnam.cv</a></li>
                <li>Thông qua biểu mẫu liên hệ trên trang web</li>
              </ul>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}